/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRewardResult.vue?vue&type=template&id=4bb4aae3&scoped=true"
import script from "./popRewardResult.vue?vue&type=script&lang=js"
export * from "./popRewardResult.vue?vue&type=script&lang=js"
import style0 from "./popRewardResult.vue?vue&type=style&index=0&id=4bb4aae3&prod&lang=css"
import style1 from "./popRewardResult.vue?vue&type=style&index=1&id=4bb4aae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4aae3",
  null
  
)

export default component.exports